<template>
  <section>
    <div class="uploadbox" v-if="parseCsv.length == 0">
      <div class="p-2 mt-3 mb-1 rounded text-center">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <h4>Example:</h4>
              File.csv<br />
              <span class="border p-2 w-100">a2m-multiservices.fr</span><br />
              <span class="border p-2 w-100">google.com</span><br />
              <span class="border p-2 w-100">cocacola.com</span><br />
            </div>
          </div>
          <div class="col-md-9">
            <div class="warning-domain mb-2">
              <h6 class="px-5">
                <img src="@/assets/images/warning_domain.png" alt="" style="width: 20px; height: 17px; position: relative; top: -2px;" class="mr-2 my-0" />
                <span class="text-danger font-weight-bold">{{ $t("lang.label.blacklist_warning") }}</span>
                <span class="text-danger font-weight-bold" :class="$store.state.authentication.user.lang_code == 'en' ? 'mr-5' : ''">{{ $t("lang.label.blacklist_explain_domain") }}</span>
                <span class="text-danger font-weight-bold">{{ $t("lang.label.blacklist_make_sure") }}</span>
              </h6>
            </div>
            <div class="bg-light p-3 card">
              <VueCsvImport
                id="importcontacts"
                v-model="parseCsv"
                headers="true"
                url="#"
                :autoMatchFields="true"
                :autoMatchIgnoreCase="true"
                buttonClass="btn btn-sm btn-primary"
                :loadBtnText="$t('lang.button.continue')"
                :fileMimeTypes="['text/csv', 'application/vnd.ms-excel']"
                :map-fields="fields"
                :key="importkey"
              >
                <template slot="submit" slot-scope="{ submit }">
                  <button
                    class="btn btn-success btn-sm w-100 p-4"
                    @click.prevent="submit"
                    @click="uploadContacts()"
                  >
                    {{ $t("lang.label.previewimport") }}
                  </button>
                </template>

                <template slot="thead">
                  <tr>
                    <th>{{ $t("lang.label.olivercolumns") }}</th>
                    <th>{{ $t("lang.label.csvcolumns") }}</th>
                  </tr>
                </template>
              </VueCsvImport>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="wrappList animated fadeIn fast"
      v-if="parseCsv.length > 0 && !loading"
    >
      <div v-if="!importing">
        <button
          v-if="error == false"
          class="w-100 float-left mt-2 btn btn-success btn-sm"
          @click="startImport()"
        >
          <i class="icon-upload"></i>
          {{ $t("lang.label.startimport") }}
        </button>

        <div class="p-2 rounded bg-danger text-white" v-if="error != false">
          <i class="icon-warning"></i> {{ this.$t("lang.mycontacts." + error) }}
        </div>

        <h5 class="mt-4">
          {{ $t("lang.label.readytoimport") }}
          {{ parseCsv.filter((el) => el.valid).length }}
          {{ $t("lang.label.contacts") }}
        </h5>
      </div>
      <div class="table-responsive" v-if="!importing">
        <table class="table table-hover card-style">
          <thead>
            <tr>
              <th v-for="(header, key) in headers">{{ header }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(company, key) in exampleList"
              :key="key"
              class="shadow-sm p-3 mb-3 bg-white rounded"
            >
              <td v-for="(header, key2) in headers">
                {{ company[key2] }}
                <span class="text-red ml-3" v-if="!company['valid']">
                  Invalid, will not be added
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="loading">
      <h6>{{ $t("lang.ondemand.importing") }}...</h6>
      <LoadingSpinner />
    </div>

    <div class="mb-1" v-if="resultProgress.length > 0">
      <!-- <div class="d-flex justify-content-end">

        </div> -->
      <div class="jumbotron pb-3 pt-2 px-2 mt-4">
        <div class="row">
          <div class="col-8">
            <h5 class="ml-3">{{ $t("lang.label.results") }}:</h5>
            <button
              @click="showResultCondition = 'added'"
              type="button"
              class="btn btn-primary ml-3 btn-sm"
            >
              {{ $t("lang.button.imported") }}
              <span class="badge badge-light ml-2">{{ domainsAdded }}</span>
            </button>
            <button
              @click="showResultCondition = 'noAdded'"
              type="button"
              class="btn btn-danger ml-3 btn-sm"
            >
              {{ $t("lang.label.error") }}
              <span class="badge badge-light ml-2">{{ domainsExists }}</span>
            </button>
            <button
              @click="showResultCondition = 'all'"
              type="button"
              class="btn btn-success ml-3 btn-sm"
            >
              {{ $t("lang.button.all") }}
              <span class="badge badge-light ml-2">{{
                resultProgress.length
              }}</span>
            </button>
          </div>
          <div
            class="col-4 px-3 py-0 mx-0 my-0 d-flex align-items-center justify-content-end"
          >
            <button @click="initial" type="button" class="btn btn-primary">
              {{ $t("lang.button.import_other_list") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <ul class="ml-3 h-100 d-inline-block" v-if="this.showResultCondition">
      <li
        v-for="(result, key) in showResult(this.showResultCondition)"
        :key="key"
      >
        <small class="text-primary" :class="result">
          {{ $t(result.name) }}</small
        >
        <small class="text-primary" :class="result">
          -
          {{
            result.added ? $t("lang.label.added") : $t("lang.label.exists")
          }}</small
        >
      </li>
    </ul>
  </section>
</template>

<script>
import { clientsService } from "@/_services";
import { VueCsvImport } from "vue-csv-import";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapActions } from "vuex";

export default {
  components: {
    VueCsvImport,
    LoadingSpinner,
  },
  props: {
    clientId: String,
  },
  data() {
    return {
      loading: false,
      showResultCondition: null,
      importkey: 1,
      pause: false,
      importlist: [],
      importname: "",
      importid: false,
      importing: false,
      resultProgress: [],
      importingfinish: false,
      exampleList: [],
      parseCsv: [],
      progress: 0,
      headers: {},
      error: false,
    };
  },
  computed: {
    domainsAdded() {
      return this.resultProgress.filter((e) => e.added).length;
    },
    domainsExists() {
      return this.resultProgress.filter((e) => !e.added).length;
    },
    fields: function () {
      return this.headers;
    },
    toastNotificationData() {
      return this.$store.state.authentication.toastNotificationData;
    },
  },
  created() {
    this.importname = "Import CSV - " + Date.now();
    this.getMyCustomFields();
  },
  methods: {
    initial() {
      this.parseCsv = [];
      this.resultProgress = [];
      this.loading = false;
      this.importing = false;
      this.showResultCondition = null;
    },
    ...mapActions("onboarding", {
      setStatusOnboarding: "setStatusOnboarding",
    }),
    showResult(value) {
      if (value === "added") {
        return this.resultProgress.filter((e) => e.added);
      }
      if (value === "noAdded") {
        return this.resultProgress.filter((e) => !e.added);
      }

      if (value === "all") {
        return this.resultProgress;
      }
    },
    selectList() {
      this.importname = "";
    },
    getMyCustomFields() {
      this.headers = {
        email: this.$t("lang.search.keywords"),
      };
    },
    finishImport() {
      this.importingfinish = true;
      this.$emit("finishImported");
      this.$forceUpdate();
    },
    startImport() {
      this.importing = true;
      this.parseCsv = this.parseCsv.filter((el) => el.valid);
      if (this.parseCsv.length == this.progress) {
        this.finishImport();
        return;
      }

      this.importWord(this.parseCsv[this.progress]);
    },
    clickpause() {
      this.pause = true;
    },
    clickplay() {
      this.pause = false;
      this.startImport();
    },
    getProgress() {
      let percentage = (this.progress * 100) / this.parseCsv.length;
      return "width: " + percentage + "%";
    },
    importWord(word) {
      this.loading = true;
      if (word.length == 0) {
        return;
      }
      if(this.$route.name == 'clients'){
        this.clientId = this.$route.params.id;
      }
      const domains = {
        importname: this.importname,
        importid: this.importid,
        client_id: this.clientId,
        name: this.parseCsv,
      };
      clientsService.importWord(domains).then((result) => {
        this.resultProgress = result;
        this.importingfinish = true;
        this.importing = true;
        this.loading = false;
        if (result) {
          const item = {
            name: "blacklist",
            value: true,
          };
          this.setStatusOnboarding(item);
          this.$emit("processFinished");
        }
      });
    },
    uploadContacts() {
      this.exampleList = [];
      for (var i = 0; i < this.parseCsv.length; i++) {
        var element = this.parseCsv[i];
        element.email = element.email.trim();

        const validDomain =
          /^(?!www\.|https:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
        const emailValid = /\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.\w{2,3})+$/;

        if (validDomain.test(element.email) || emailValid.test(element.email)) {
          element.valid = true;
        } else {
          element.valid = false;
        }

        this.exampleList.push(element);
      }

      if (this.exampleList[0] == undefined) {
        this.error = "csvempty";
        return;
      }
      if (this.exampleList[0]["email"] == undefined) {
        this.error = "notemail";
        return;
      }
    },
  },
};
</script>

<style>
.vue-csv-uploader-part-one {
  width: 100%;
  float: left;
}
.vue-csv-uploader-part-two {
  width: 100%;
  float: left;
}
.import .wrappList table,
.vue-csv-uploader-part-two table {
  width: 100% !important;
  text-align: left;
}
#preview {
  height: 100vh;
  overflow: scroll !important;
  width: 100% !important;
}
#preview small.text-danger.contact-imported {
  color: #53be80 !important;
}
.linedotted {
  border-style: dashed !important;
}
.form-control-file {
  display: block;
  position: relative;
  width: 200px !important;
  margin: auto;
  cursor: pointer;
  height: 40px;
  border-radius: 5px;
  outline: 0;
  border: 1px solid #909090;
  border-style: dashed;
  padding: 15px;
}
.form-control-file:hover:after {
  background: #5978f8;
}
.form-control-file:after {
  transition: 200ms all ease;
  border-bottom: 3px solid rgba(0, 0, 0, 0.2);
  background: #3c5ff4;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
  font-size: 16px;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  content: "Select CSV File";
  line-height: 40px;
  border-radius: 5px;
}

.download-template > div {
  color: grey;
  position: relative;
  font-weight: bold;
}
.download-template > div:before,
.download-template > div:after {
  position: absolute;
  display: block;
  width: 100px;
  height: 1px;
  content: "";
  background: grey;
  right: calc(50% + 25px);
  top: 10px;
}
.download-template > div:after {
  right: inherit;
  left: calc(50% + 25px);
}
.warning-domain {
  background-color: #ebebeb; 
  border: 3px solid rgb(255, 0, 0);  
  padding: 0.8rem;        
}
</style>
